// Entry point (single IIFE, see vite.config.ts): registers <ask-jumino-chat>
// and exposes window.AskJumino.

import { AskJuminoChatElement } from './element';
import { clearStoredSession, StorageKind } from './state/sessionStore';
import type { AskJuminoConfig } from './config';

if (!customElements.get('ask-jumino-chat')) {
  customElements.define('ask-jumino-chat', AskJuminoChatElement);
}

declare global {
  interface Window {
    AskJumino?: {
      version: string;
      mount: (target: HTMLElement, config: Partial<AskJuminoConfig>) => AskJuminoChatElement;
      clearSession: (storageKey?: string, storage?: StorageKind) => void;
    };
  }
}

if (!window.AskJumino) {
  window.AskJumino = {
    version: __ASK_JUMINO_VERSION__,
    mount(target: HTMLElement, config: Partial<AskJuminoConfig>): AskJuminoChatElement {
      const el = document.createElement('ask-jumino-chat') as AskJuminoChatElement;
      el.config = config;
      target.appendChild(el);
      return el;
    },
    clearSession(storageKey = 'ask-jumino-conversation', storage: StorageKind = 'local'): void {
      clearStoredSession(storageKey, storage);
    },
  };
}

export { AskJuminoChatElement };
